import { format } from 'date-fns'

const DAY_FORMAT = 'yyyy-MM-dd'
const TIME_FORMAT = 'HH:mm:ss'

const adjustForUTCOffset = (date: Date) => {
  if (date) {
    return new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds()
    )
  }
  return undefined
}

export const toServerFormat = (value: Date) => {
  const date = adjustForUTCOffset(value)
  return date ? `${format(date, DAY_FORMAT)}T${format(date, TIME_FORMAT)}` : ''
}

export const getWTZDate = (date?: string) => {
  if (date && date.includes('Z')) {
    return new Date(date)
  }
  const getTimeZone = (new Date().getTimezoneOffset() * -1) / 60
  const oldDate = date ? new Date(date) : new Date()
  oldDate.setHours(oldDate.getHours() + getTimeZone)
  return oldDate
}
